import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';

import {
  Box, Button, createStyles, Dialog, Grid, IconButton, makeStyles, Theme, Typography, useTheme, Fade, Slide
} from '@material-ui/core';
import { ArrowBack, ArrowDownward, ArrowForward, ArrowRight, Close } from '@material-ui/icons';
import AddTaskIcon from '@mui/icons-material/AddTask';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import Icon from '@mui/material/Icon';

import { FareastButton } from './OverlayComponentButton';
import { useAppDispatch, useAppSelector } from '../reduxhooks';
import { Order } from 'common-ts/dist/models/Orders';
import { BodyMeasurements } from 'common-ts/dist/models/UserMeasurements';
import { closeOverlayAndReset as closeOverlayAndResetEditView, openOverlay as openOverlayEditView, setValues as setValuesEditView } from '../redux/UIOverlayMeasurementEditViewRedux';
import React, { useEffect } from 'react';
import OverlayComponentButton from './OverlayComponentButton';
import { Player } from '@lottiefiles/react-lottie-player';
import { TypeAnimation } from 'react-type-animation';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backButton: {
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
      backgroundColor: 'black',
      borderRadius: '50%',
      padding: '5px',
    },
    backButtonIcon: {
      padding: '0',
      color: 'white',
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      // padding: '1em 1.5em',
      // overflowY: 'hidden',
    },
    pageTitle: {
      marginTop: '1em',
      fontSize: '1.2em',
      width: '80%',
      fontWeight: 550,
    },
    pageItem: {
      display: 'grid',
      gridTemplateColumns: '1fr 8fr',
      marginTop: '1em',
    },
    pageItemIcon: {
      marginRight: '0.2em',
    },
    pageItemTitle: {
      paddingTop: '0.2em',
      fontSize: '0.8em',
      fontWeight: 500,
    },
    pageItemDescription: {
      gridColumn: '2',
      paddingTop: '0.2em',
      paddingRight: '0.5em',
      fontSize: '0.7em',
    },
  }),
);

export function StarWarsNameCard({name, isOneName=false}: {name: string, isOneName?: boolean}) {
  return (
    <Box style={{
      width: '100%',
      position: 'relative',
      margin: '20px 0px 2px',
      minHeight: '80%',
    }}>
      <video muted autoPlay loop src={'https://studiosclo.uk/general/Profil_Personal_Fit_Card_05.mp4'}
      playsInline
        style={{
          width: '100%'
        }}
      />
      <Typography style={{
        position: 'absolute',
        top: '75%',
        left: '28%',
        fontSize: '10%',
        fontWeight: 500,
        color: '#ffffff',
      }}>
        13 April 2025
      </Typography>
      <TypeAnimation
        sequence={
          isOneName ? [
          name,
          2400, 
          'KAMU',
          2400
        ] : [
          'Louis',
          900, // Waits 1s
          name,
          2400, // Waits 1s
          'Ubay', 
          900, // Waits 1s
          'Mike',
          900,
          'KAMU',
          3400
        ]}
        wrapper="div"
        cursor={true}
        repeat={Infinity}
        style={{ 
          position: 'absolute',
          top: '54.1%',
          left: '28%',
          fontSize: '4.3vw',
          fontFamily: 'OakesGrotesk',
          fontWeight: 500,
          color: '#ffffff',
        }}
        speed={12}
      />
    </Box>
  )
}

interface Props {
  handleBack: () => void
  handleNext: (updatedCurrentFlowData: any) => void
}

export default function PersonalSizeBenefit({ handleBack, handleNext }: Props) {
  const classes = useStyles();

  const [cobaSekarangIndex, setCobaSekarangIndex] = React.useState(0);
  const firstName = useAppSelector(state => state.account.name?.split(' ')?.[0] ?? 'Fariz');

  const [numberCountObj, setNumberCountObj] = React.useState({
    currentCount: 250,
    targetCount: 300,
    lastAddTargetCount: 50,
    macamStr: 'MACAM KAOS'
  })

  useEffect(() => {
    const element = document.getElementById("univ-size-benefit-0");
    if (element) {
      element.scrollIntoView({behavior: "smooth", block: 'center'});
    }

    const intervalId = setInterval(() => {
      setCobaSekarangIndex(t => (t + 1) % 3);
    }, 4000);

    const intervalIdTarget = setInterval(() => {
      const randomInt = Math.round(24 + Math.random() * 17);
      const macamStr = ['MACAM POLO', 'MACAM KAOS', 'MACAM KEMEJA', 'MACAM BATIK']?.[(Math.round(10 * Math.random()) % 4)];
      setNumberCountObj(t => ({ 
        currentCount: t.currentCount,
        targetCount: t.targetCount > 500 ? randomInt : t.targetCount + randomInt,
        lastAddTargetCount: randomInt,
        macamStr: macamStr,
      }));
    }, 2800);
    const intervalIdCurrentToTarget = setInterval(() => {
      setNumberCountObj(t => ({ 
        currentCount: t.currentCount === t.targetCount ? t.currentCount : t.currentCount < t.targetCount ? t.currentCount + 1 : 1,
        targetCount: t.targetCount,
        lastAddTargetCount: t.lastAddTargetCount,
        macamStr: t.macamStr,
      }));
    }, 30);

    return () => {
      clearInterval(intervalId);
      clearInterval(intervalIdTarget);
      clearInterval(intervalIdCurrentToTarget);
    };
  }, []);
  
  return (
  <>
    <Box  id='univ-size-benefit-0' ></Box>
    <Box style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center'
    }}>
      <Box style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }} onClick={() => {
        handleNext('');
      }}>
        <Typography style={{
          fontSize: '11px',
          color: 'rgb(98,98,98)',
          marginTop: '30px',
          letterSpacing: '0.5px'
        }}>
          PROFIL UKURAN PERSONAL
        </Typography>
        <Typography style={{
          fontSize: '28px',
          fontWeight: 600,
          marginTop: '10px',
        }}>
          Buat Semua Jadi Pas
        </Typography>
        <Typography style={{
          fontSize: '9.4px',
          color: 'rgb(114, 114, 114)',
          textAlign: 'center',
          margin: '7px 20px -14px',
          letterSpacing: '0.1px',
          fontWeight: 300,
        }}>
          Dengan Ukuran Personal, semua item yang kamu beli akan<br/> datang dengan pas dan sesuai dengan yang kamu mau.
        </Typography>
        <StarWarsNameCard name={firstName} isOneName={true}/>
      </Box>
      <Box style={{width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '-7px',
      }}>
        <Box style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: '10px'}}>
          <Button style={{
            color: 'white',
            backgroundColor: '#121212',
            borderRadius: '30px',
            padding: '8px 15px 4px 15px',
            fontSize: '11px',
            letterSpacing: '0.7px',
            margin: '10px 23px'
          }} fullWidth
          onClick={() => {
            handleNext('');
          }}
          >
            BUAT PUNYA {firstName?.toUpperCase()}
          </Button>
        </Box>
      </Box>
    </Box>
  </>);
}